// Feature flags / runtime toggles. Read once at boot; treat as immutable.
//
// Today flags are derived from config (no remote flag service). When/if a
// provider lands (LaunchDarkly, GrowthBook, custom backend), wire it here so
// callers continue to read from `flags.*` without knowing the source.

import { config } from './config'

export const flags = {
  // Sentry only initialises when a DSN is set — handy in dev to opt-in for a
  // single session without changing the bootstrap order.
  sentryEnabled: config.sentry.dsn.length > 0,

  // Mixpanel only initialises when a token is set. Same reasoning.
  analyticsEnabled: config.mixpanel.token.length > 0,

  // Web Vitals reporting can be toggled per environment (default: on
  // everywhere except local dev to keep the dev console quiet).
  webVitalsEnabled: config.webVitals.enabled,
} as const
